import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <h1 {...{
      "id": "mdx-jsruntime"
    }}><inlineCode parentName="h1">{`@mdx-js/runtime`}</inlineCode></h1>
    <p><a parentName="p" {...{
        "href": "https://github.com/mdx-js/mdx/actions"
      }}><img parentName="a" {...{
          "src": "https://github.com/mdx-js/mdx/workflows/CI/badge.svg",
          "alt": "Build"
        }}></img></a>{`
`}<a parentName="p" {...{
        "href": "https://www.npmjs.com/package/@mdx-js/runtime"
      }}><img parentName="a" {...{
          "src": "https://img.shields.io/npm/dm/@mdx-js/runtime.svg",
          "alt": "Downloads"
        }}></img></a>{`
`}<a parentName="p" {...{
        "href": "https://opencollective.com/unified"
      }}><img parentName="a" {...{
          "src": "https://opencollective.com/unified/sponsors/badge.svg",
          "alt": "Sponsors"
        }}></img></a>{`
`}<a parentName="p" {...{
        "href": "https://opencollective.com/unified"
      }}><img parentName="a" {...{
          "src": "https://opencollective.com/unified/backers/badge.svg",
          "alt": "Backers"
        }}></img></a>{`
`}<a parentName="p" {...{
        "href": "https://github.com/mdx-js/mdx/discussions"
      }}><img parentName="a" {...{
          "src": "https://img.shields.io/badge/chat-discussions-success.svg",
          "alt": "Chat"
        }}></img></a></p>
    <p>{`A `}{`[React][]`}{` component that evaluates `}<a parentName="p" {...{
        "href": "https://mdxjs.com"
      }}>{`MDX`}</a>{`.`}</p>
    <blockquote>
      <p parentName="blockquote">{`⚠️ `}<strong parentName="p">{`warning`}</strong>{`: this is not the preferred way to use MDX since it
introduces a substantial amount of overhead and dramatically increases
bundle sizes.
It must not be used with user input that isn’t sandboxed.`}</p>
    </blockquote>
    <h2 {...{
      "id": "install"
    }}>{`Install`}</h2>
    <p><a parentName="p" {...{
        "href": "https://docs.npmjs.com/cli/install"
      }}>{`npm`}</a>{`:`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-sh"
      }}>{`npm install @mdx-js/runtime
`}</code></pre>
    <p><a parentName="p" {...{
        "href": "https://yarnpkg.com/cli/add"
      }}>{`yarn`}</a>{`:`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-sh"
      }}>{`yarn add @mdx-js/runtime
`}</code></pre>
    <h2 {...{
      "id": "use"
    }}>{`Use`}</h2>
    <p>{`Say we have the following scripts, `}<inlineCode parentName="p">{`example.jsx`}</inlineCode>{`:`}</p>
    <h3 {...{
      "id": "props"
    }}>{`Props`}</h3>
    <p>{`The MDX Runtime component accepts two props:`}</p>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": null
          }}>{`Name`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Description`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`components`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Globally available components for the runtime`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`scope`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Variables that are accessible in the JSX portion of the document`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`remarkPlugins`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Array of remark plugins`}</td>
        </tr>
      </tbody>
    </table>
    <h3 {...{
      "id": "example-code"
    }}>{`Example code`}</h3>
    <pre><code parentName="pre" {...{
        "className": "language-jsx"
      }}>{`import React from 'react'
import {renderToString} from 'react-dom/server'
import MDX from '@mdx-js/runtime'

// Custom components:
const components = {
  h1: props => <h1 style={{color: 'tomato'}} {...props} />,
  Demo: () => <p>This is a demo component</p>
}

// Data available in MDX:
const scope = {
  somethingInScope: 1
}

// The MDX:
const children = \`
# Hello, world!

{1 + somethingInScope}

<Demo />

<div>Here is the scope variable: {some}</div>
\`

const result = renderToString(
  <MDX components={components} scope={scope} children={children} />
)

console.log(result)
`}</code></pre>
    <p>{`Now, building, bundling, and finally running it, yields:`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-html"
      }}>{`<h1 style="color:tomato">Hello, world!</h1>2<p>This is a demo component</p>
`}</code></pre>
    <h2 {...{
      "id": "contribute"
    }}>{`Contribute`}</h2>
    <p>{`See `}<a parentName="p" {...{
        "href": "https://mdxjs.com/contributing"
      }}>{`Contributing on `}<inlineCode parentName="a">{`mdxjs.com`}</inlineCode></a>{` for ways to get started.
See `}<a parentName="p" {...{
        "href": "https://mdxjs.com/support"
      }}>{`Support`}</a>{` for ways to get help.`}</p>
    <p>{`This project has a `}<a parentName="p" {...{
        "href": "https://github.com/mdx-js/.github/blob/master/code-of-conduct.md"
      }}>{`code of conduct`}</a>{`.
By interacting with this repository, organization, or community you agree to
abide by its terms.`}</p>
    <h2 {...{
      "id": "license"
    }}>{`License`}</h2>
    <p><a parentName="p" {...{
        "href": "license"
      }}>{`MIT`}</a>{` © `}<a parentName="p" {...{
        "href": "https://compositor.io"
      }}>{`Compositor`}</a>{` and `}<a parentName="p" {...{
        "href": "https://vercel.com"
      }}>{`Vercel`}</a></p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      